module.exports = __webpack_public_path__ + "img/q1-levit.8601203a.svg";